import { render, staticRenderFns } from "./adhoc-drive-edit-page.vue?vue&type=template&id=38310160"
import script from "./adhoc-drive-edit-page.vue?vue&type=script&lang=ts"
export * from "./adhoc-drive-edit-page.vue?vue&type=script&lang=ts"
import style0 from "./adhoc-drive-edit-page.vue?vue&type=style&index=0&id=38310160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports